<template>
  <section v-if="loading">
    <Grid>
      <GridItem         :sm="sizes.sm"
                        :md="sizes.md"
                        :xl="sizes.xl" class="fshr-resortCardList__item" v-for="index in 6">
        <TripCardLoading />
      </GridItem>
    </Grid>
  </section>
  <section v-else class="fshr-resortCardList">
    <Grid>
      <GridItem
        :sm="sizes.sm"
        :md="sizes.md"
        :xl="sizes.xl"
        v-for="resort in resorts"
        :key="resort.id"
        class="fshr-resortCardList__item"
      >
        <ResortCard :resort="resort" :translations="translations" :season="season" :logged="logged" :api_url_watchdoglogged="api_url_watchdoglogged" :api_url_watchdog="api_url_watchdog"/>
      </GridItem>
    </Grid>

    <popup
            type="standard"
            :has_opener="false"
            popupid="skimap"
            :fullscreen="true"
    >
      <template v-slot:main-content>
        <skimap :skimap_url="skimap_url"></skimap>
      </template>
      <template v-slot:main-header>
        <div></div>
      </template>
    </popup>

  </section>
</template>

<script>
import Grid from "./elements/Grid.vue";
import GridItem from "./elements/GridItem.vue";
import TripCardLoading from "./TripCardLoading.vue";
import ResortCard from "./ResortCard.vue";
import Skimap from "../components/Skimap.vue";
import Popup from "./Popup.vue";

export default {
  name: "resort-card-list",

  components: {
    Grid,
    GridItem,
    ResortCard,
    TripCardLoading,
    Skimap,
    Popup,
  },

  props: {
    resorts: {
      type: Array,
      required: true,
    },
    loading: {
      required: false,
      type: Boolean,
      default: true,
    },
    logged: {
      type: Boolean,
      required: false,
      default: false,
    },
    api_url_watchdoglogged: {
      default: "",
      type: String,
      required: false
    },
    api_url_watchdog: {
      default: "",
      type: String,
      required: false
    },
    translations: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    season: {
      type: Number,
      required: false,
      default: 1
    },
    skimap_url: {
      required: false,
      type: String,
      default: "https://www.nev-dama.cz/Data/skimapy2/",
    },
    sizes: {
      type: Object,
      required: false,
      default: () =>{
        return {
          sm: 12,
          md: 6,
          xl: 6,
        }
      }
    }
  },
};
</script>

<style lang="less">
  @import './../less/variables';
  @import './../../../../../Content/css/components/component-resort-card-list';
</style>